import { z } from "zod";

export const rescheduleMeetingSchema = z
	.object({
		proposed_date: z.iso.datetime({ message: "Proposed date is required" }),
		reason: z.string().max(500).optional(),
	})
	.strict();

export type RescheduleMeetingPayload = z.infer<typeof rescheduleMeetingSchema>;
